<template>
  <div testek="base-list" :class="isShowFiler ? 'mt-4 p-6' : ''">
    <div
      class="mb-5 flex justify-between items-center w-full overflow-auto header-content-list"
    >
      <div class="filters flex items-center" v-if="isShowFiler">
        <div
          class="category-info flex mr-4 w-48 items-center"
          v-if="isShowCategory"
        >
          <a-select
            v-model:value="params.category"
            show-search
            :placeholder="$t('i18nCommon.Category')"
            :filterOption="false"
            @focus="loadDataCategory"
            @change="onChangeCategory"
            @search="filterDataCategory"
            class="w-full"
            :popupClassName="'dropdown-menu-category'"
            :field-names="{
              label: `categoryName`,
              value: `id`,
            }"
            :options="categoryFilters"
          >
            <template #option="{ isTitle, categoryName, cateDesc }">
              <tr
                :class="isTitle ? 'font-bold select-title' : ''"
                :disabled="isTitle"
                @click="isTitle ? $event.stopPropagation() : null"
              >
                <td class="td-item td-item-category">
                  {{ categoryName }}
                </td>
                <td class="td-item td-item-category">
                  {{ cateDesc }}
                </td>
              </tr>
            </template>
          </a-select>
        </div>
        <div
          class="supplier-info flex w-48 mr-4 items-center"
          v-if="isShowSupplier"
        >
          <a-select
            v-model:value="params.suppliers"
            show-search
            :placeholder="$t('i18nCommon.Supplier')"
            :filterOption="false"
            @focus="loadDataSupplier"
            @change="onChangeSupplier"
            @search="filterDataSupplier"
            testek="supplier-combobox"
            class="w-full"
            :popupClassName="'dropdown-menu-supplier'"
            :options="supplierFilters"
            :field-names="{
              label: `supName`,
              value: `id`,
            }"
          >
            <template
              #option="{ isTitle, supName, supContactName, supAddress }"
            >
              <tr
                :class="isTitle ? 'font-bold select-title' : ''"
                @click="isTitle ? $event.stopPropagation() : null"
                :disabled="isTitle"
              >
                <td
                  class="td-item td-item-supplier"
                  :class="isTitle ? 'font-bold' : ''"
                >
                  {{ supName }}
                </td>
                <td
                  class="td-item td-item-supplier"
                  :class="isTitle ? 'font-bold' : ''"
                >
                  {{ supContactName }}
                </td>

                <td
                  class="td-item td-item-supplier"
                  :class="isTitle ? 'font-bold' : ''"
                >
                  {{ supAddress }}
                </td>
              </tr>
            </template>
          </a-select>
        </div>
        <div
          class="supplier-info flex w-48 mr-4 items-center"
          v-if="isShowStatus"
        >
          <a-select
            v-model:value="params.status"
            show-search
            :placeholder="$t('i18nCommon.Status')"
            :options="statuses"
            @focus="loadDataStatus"
            @change="onChangeStatus"
            :field-names="{
              label: `status`,
              value: `id`,
            }"
            class="w-full h-full"
            testek="status-combobox"
            :dropdown-menu-style="{
              width: '800px',
              backgroundColor: '#f0f0f0',
            }"
          >
          </a-select>
        </div>
        <div
          class="supplier-info flex w-48 mr-4 items-center"
          v-if="isShowOrderStatus"
        >
          <a-select
            v-model:value="params.status"
            show-search
            :placeholder="$t('i18nCommon.OrderStatus')"
            :options="orderStatuses"
            @focus="loadDataOrderStatus"
            @change="onChangeOrderStatus"
            :field-names="{
              label: `status`,
              value: `id`,
            }"
            class="w-full h-full flex items-center"
            testek="order-status-combobox"
          ></a-select>
        </div>
        <div class="search-text flex w-60 mr-4 items-center">
          <a-input
            v-model:value="params.keyword"
            :placeholder="'keyword'"
            testek="search-input"
            class="h-8"
          >
          </a-input>
        </div>
        <div class="btn-add font-bold mr-4 h-8">
          <a-button
            testek="btn-cancel-filter"
            @click="filterCancel"
            :height="32"
            class="flex items-center"
          >
            <template #icon>
              <CloseCircleOutlined />
            </template>
            Clear
          </a-button>
        </div>
        <div class="btn-search font-bold mr-4">
          <a-button
            type="primary"
            testek="btn-search"
            @click="loadDataFilter"
            :height="32"
          >
            {{ $t("i18nCommon.Search") }}
          </a-button>
        </div>
      </div>
      <div class="flex items-center">
        <div class="btn-add font-bold mr-2" v-if="titleAdd">
          <a-button
            type="primary"
            testek="btn-add"
            @click="addData"
            :height="32"
            class="flex items-center"
          >
            <template #icon>
              <PlusCircleOutlined />
            </template>
            {{ titleAdd }}
          </a-button>
        </div>
        <div class="btn-add font-bold mr-2" v-if="isShowExport">
          <a-button
            type="primary"
            testek="btn-export"
            :height="32"
            class="flex items-center"
            @click="exportToExcel"
          >
            <template #icon>
              <ExportOutlined />
            </template>
            {{ $t("i18nCommon.Export") }}
          </a-button>
        </div>
        <div class="btn-add font-bold" v-if="isShowPrint">
          <a-button
            testek="btn-export"
            :height="32"
            class="flex items-center"
            @click="printToPdf"
          >
            <template #icon>
              <PrinterOutlined />
            </template>
            {{ $t("i18nCommon.Print") }}
          </a-button>
        </div>
      </div>
    </div>
    <div class="w-full overflow-auto" id="printable-content" testek="grid">
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="scroll"
        testek="table"
        :customRow="rowEvents"
        :rowClassName="'row-table'"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.columnKey === 'name'">
            <div class="name-text">{{ record[`${column.dataIndex}`] }}</div>
          </template>
          <template
            v-if="
              record && column.keyIndex === 'supplierObject' && record.supplier
            "
          >
            <div class="name-text">
              {{ record.supplier[`${column.dataIndex}`] }}
            </div>
          </template>
          <template
            v-if="
              record && column.keyIndex === 'categoryObject' && record.category
            "
          >
            <div class="name-text">
              {{ record.category[`${column.dataIndex}`] }}
            </div>
          </template>
          <template
            v-if="record && column.dataIndex === 'status' && record.status"
          >
            <span>
              <a-tag
                :color="
                  record &&
                  record.status &&
                  (record.status.toUpperCase() === 'INACTIVE' ||
                    record.status.toUpperCase() === 'CANCELLED')
                    ? 'volcano'
                    : 'green'
                "
              >
                {{ record.status.toUpperCase() }}
              </a-tag>
            </span>
          </template>
          <template
            v-if="
              record &&
              column.dataIndex === 'accountState' &&
              record.accountState
            "
          >
            <span>
              <a-tag
                :color="
                  record &&
                  record.accountState &&
                  (record.accountState.toUpperCase() === 'INACTIVE' ||
                    record.accountState.toUpperCase() === 'CANCELLED')
                    ? 'volcano'
                    : 'green'
                "
              >
                {{ record.accountState.toUpperCase() }}
              </a-tag>
            </span>
          </template>
          <template v-if="column.key === 'rightWidgetDefault'">
            <div class="flex">
              <div
                class="icon-24 mr-4 cursor-pointer btn-edit flex items-center justify-center"
                @click="editRow(record)"
                :title="$t('i18nCommon.Edit')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-edit icon-16"
                >
                  <path
                    d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                  ></path>
                  <path
                    d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                  ></path>
                </svg>
              </div>
              <div
                class="btn-delete icon-24 mr-4 cursor-pointer flex items-center justify-center"
                @click="deleteRow(record)"
                :title="$t('i18nCommon.Delete')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-x icon-16"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
              <slot name="actionMore" :record="record"></slot>
            </div>
          </template>
          <template v-if="column.key === 'rightWidget'">
            <slot name="rightWidget" :record="record"></slot>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { ModuleCategory, ModuleSupplier } from "@/store/module-const";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
  name: "BaseList",
  props: {
    payload: {},
    data: {
      default: [],
      typeof: Array,
    },
    pagination: {},
    columns: {
      default: [],
      typeof: Array,
    },
    rowKey: {
      type: String,
      default: "id",
    },
    titleAdd: {
      default: "",
      typeof: String,
    },
    name: {
      default: "",
      str: String,
    },
    isShowFiler: {
      default: true,
      typeof: Boolean,
    },
    scroll: {
      default: {
        y: "calc(100vh - 420px)",
      },
    },
    isShowCategory: {
      default: false,
      typeof: Boolean,
    },
    isShowSupplier: {
      default: false,
      typeof: Boolean,
    },
    isShowStatus: {
      default: false,
      typeof: Boolean,
    },
    isShowOrderStatus: {
      default: false,
      typeof: Boolean,
    },
    isShowPrint: {
      default: true,
      typeof: Boolean,
    },
    isShowExport: {
      default: true,
      typeof: Boolean,
    },
  },
  async created() {
    const me = this;
  },
  mounted() {},
  data() {
    return {
      params: {
        type: "",
        category: [],
        keyword: "",
        limit: 10,
        page: 1,
        sort: [],
      },
      statuses: [],
      orderStatuses: [],
      sortedInfo: {},
    };
  },
  computed: {
    ...mapGetters(ModuleCategory, ["Categories"]),
    ...mapGetters(ModuleSupplier, ["Suppliers"]),
    categoryFilters() {
      const me = this;
      let firstData = {
        categoryName: me.$t("i18nCommon.CategoryInfo.CategoryName"),
        cateDesc: me.$t("i18nCommon.CategoryInfo.CategoryDescription"),
        isTitle: true,
      };

      if (!me.Categories || me.Categories.length <= 0) {
        return [firstData];
      }

      let categories = [firstData, ...me.Categories];
      return categories;
    },

    supplierFilters() {
      const me = this;
      let firstData = {
        supName: me.$t("i18nCommon.SupplierInfo.Name"),
        supContactName: me.$t("i18nCommon.SupplierInfo.ContactName"),
        supAddress: me.$t("i18nCommon.SupplierInfo.Address"),
        isTitle: true,
      };

      if (!me.Suppliers || me.Suppliers.length <= 0) {
        return [firstData];
      }

      let suppliers = [firstData, ...me.Suppliers];
      return suppliers;
    },
    // columnInfos() {
    //   const me = this;
    //   const filtered = filteredInfo.value || {};
    //   const sorted = sortedInfo.value || {};
    // },
  },
  methods: {
    ...mapActions(ModuleCategory, ["getCategoriesList"]),
    ...mapActions(ModuleSupplier, ["getSuppliersList"]),
    initDataStatic() {
      const me = this;
    },
    handleTableChange(pag, filters, sorter, { action, currentDataSource }) {
      if (action === "sort") {
        // this.sortedInfo = sorter;
        return;
      }
      this.$emit("change", pag, filters, sorter, action, currentDataSource);
    },
    rowEvents(record) {
      const me = this;
      return {
        onClick: (event) => {
          me.$emit("onClick", record);
        },
        onDblclick: (event) => {
          me.$emit("onDblclick", record);
        },
        onContextmenu: (event) => {
          me.$emit("onContextmenu", record);
        },
        onMouseenter: (event) => {
          me.$emit("onMouseenter", record);
        },
        onMouseleave: (event) => {
          me.$emit("onMouseleave", record);
        },
      };
    },

    handleRowClick() {
      // Logic khi click vào một dòng
      console.log("Row clicked:", record);
    },

    onChangeCategory: _.debounce(function (payload) {
      const me = this;
    }, 500),

    onChangeSupplier: _.debounce(function (payload) {
      const me = this;
    }, 500),

    onChangeStatus: _.debounce(function (payload) {
      const me = this;
      let status = me.statuses.find((x) => x.id == payload);
      if (status) {
        me.params.status = status.id;
      }
    }, 500),

    onChangeOrderStatus: _.debounce(function (payload) {
      const me = this;
      let status = me.orderStatuses.find((x) => x.id == payload);
      if (status) {
        me.params.status = status.id;
      }
    }, 500),

    loadDataFilter: _.debounce(async function () {
      const me = this;
      debugger;
      this.$emit("loadDataFilter", me.params);
    }, 300),

    async loadDataCategory() {
      const me = this;
      if (me.Categories && me.Categories.length > 0) return;
      await me.getCategoriesList();
    },

    async loadDataSupplier() {
      const me = this;
      if (me.Suppliers && me.Suppliers.length > 0) return;
      await me.getSuppliersList();
    },

    loadDataStatus: _.debounce(async function () {
      const me = this;
      me.statuses = this.$config.StatusInfos;
    }, 300),

    loadDataOrderStatus: _.debounce(async function () {
      const me = this;
      me.orderStatuses = this.$config.OrderStatusInfos;
    }, 300),

    filterDataSupplier: _.debounce(async function (searchText) {
      const me = this;
      await me.getSuppliersList({
        keyword: searchText,
      });
    }, 500),
    filterDataCategory: _.debounce(async function (searchText) {
      const me = this;
      await me.getCategoriesList({
        keyword: searchText,
      });
    }, 300),
    addData() {
      this.$emit("addData");
    },
    editRow(dataRow) {
      this.$emit("editRow", dataRow);
    },
    deleteRow(dataRow) {
      this.$emit("deleteRow", dataRow);
    },

    filterCancel() {
      const me = this;
      me.params = {
        type: "",
        category: "",
        keyword: "",
        limit: 10,
        page: 1,
        sort: [],
        suppliers: null,
        status: null,
        category: null,
      };
      me.$emit("filterCancel");
      me.$emit("loadDataFilter", me.params);
    },
    exportToExcel() {
      const me = this;
      // Tiêu đề cột
      const header = [this.columns.map((x) => x.title)];
      const keys = this.columns.map((x) => x.dataIndex);
      const datax = this.data.map(
        (item) => keys.map((key) => item[key]) // Lấy giá trị từng thuộc tính theo danh sách keys
      );
      const worksheetData = [...header, ...datax];
      // Tạo worksheet và workbook
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      // Xuất file Excel
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Lưu file
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, "DanhSach.xlsx");
    },

    printToPdf() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/contents/scss/views/base/BaseList.scss");

.grid-viewer {
  height: calc(100vh - 270px);
}

.btn-edit {
  &:hover {
    background: #0abb87;
    color: #fff;
    border: 1px solid #0abb87;
    border-radius: 50%;
  }
}

.btn-delete {
  &:hover {
    background: #fd1361;
    color: #fff;
    border: 1px solid #fd1361;
    border-radius: 50%;
  }
}

.status-inactive {
  color: #d4380d;
  background: #fff2e8;
  border: 1px solid #ffbb96;
  border-radius: 8px;
}

.status-active {
  color: #389e0d;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 8px;
}

.name-text {
  color: #29689e;
}

::v-deep(.ant-table-body) {
  scrollbar-width: thin !important; /* Firefox */
  scrollbar-color: #706f6f #f0f0f0 !important; /* Màu cuộn và nền */
}

::v-deep(.ant-table-body::-ebkit-scrollbar) {
  width: 8px !important; /* Độ rộng thanh cuộn */
  height: 8px !important;
}

::v-deep(.ant-table-body::-webkitscrollbar-thumb) {
  background-color: #e5e5e5 !important; /* Màu của thanh kéo */
  border-radius: 4px !important;
}

::v-deep(.ant-table-body::-webkitscrollbar-track) {
  background: #e5e5e5 !important; /* Màu nền thanh cuộn */
  border-radius: 4px !important;
}

::v-deep(.row-table:hover .ant-table-cell) {
  background-color: #e5e5e5 !important;
}

::v-deep(.row-table .ant-table-cell-fix-left),
::v-deep(.row-table .ant-table-cell-fix-right) {
  &:hover {
    background-color: #e5e5e5 !important;
  }
}

/* Hiệu ứng hover cho tiêu đề */
::v-deep(.ant-table-thead th) {
  background-color: #c9c8c8 !important;
}

.filter-cancel-box {
  background-color: #fff;
  border: 1px solid #f1f1f5;
  color: #4e5e6a;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  &:hover {
    background: #e6e6e6;
  }

  &:active {
    background: #e6e6e6;
  }
}

::v-deep(.header-content-list) {
  scrollbar-width: thin !important; /* Firefox */
  scrollbar-color: #706f6f #f0f0f0 !important; /* Màu cuộn và nền */
}

::v-deep(.header-content-list::-ebkit-scrollbar) {
  width: 8px !important; /* Độ rộng thanh cuộn */
  height: 8px !important;
}

::v-deep(.header-content-list::-webkitscrollbar-thumb) {
  background-color: #e5e5e5 !important; /* Màu của thanh kéo */
  border-radius: 4px !important;
}

::v-deep(.header-content-list::-webkitscrollbar-track) {
  background: #e5e5e5 !important; /* Màu nền thanh cuộn */
  border-radius: 4px !important;
}
</style>
